import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import withBackToDashboard from 'components/hoc/Cards/withBackToDashboard';
import withTracker from 'components/hoc/Cards/withTracker';

import Card from 'components/molecules/Card';
import { CardProps } from 'components/molecules/Card';
import cardRenderLocation from 'containers/molecules/Card/enum-card-render-location';

import { actionCreators as programItemsAC } from 'store/programItems';

const mapStateToProps = (state, ownProps): CardProps => ({
	...ownProps,
	id: ownProps.externalId,
	state: 'feed',
	uiState: 'detail',
	type: ownProps.type,
	cardRenderLocation: cardRenderLocation.DASHBOARD,
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doToggleFavorite: programItemsAC.doToggleFavorite,
		},
		dispatch
	);
};

export default withBackToDashboard(withTracker(connect(mapStateToProps, mapDispatchToProps)(Card)));
